import ReviewAnime from "./src/ReviewAnime";

export default ReviewAnime